import { useContext } from 'react';
import { DatadogRumContext } from './context.js';

/**
 * Datadog Rum Context Hook.
 */ const useDatadogRum = ()=>{
    return useContext(DatadogRumContext);
};

export { useDatadogRum };
//# sourceMappingURL=index.js.map
